/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * RakeBack Wizard API
 * OpenAPI spec version: 1.0.0
 */
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query'

import type { PaginatedEarningHistoryList, Report, ReportEarningHistoryListParams } from '../models'

import reportEarningHistoryListMutator from '../../client'
import reportListListMutator from '../../client'

/**
 * API view to retrieve the user's complete earning history.

Returns aggregated data grouped by Year/Month/Poker Room combination,
ordered by Year DESC, Month DESC, Poker Room ASC.
 */
export const reportEarningHistoryList = (
  params?: ReportEarningHistoryListParams,
  signal?: AbortSignal,
) => {
  return reportEarningHistoryListMutator<PaginatedEarningHistoryList>({
    url: `/api/v1/report/earning-history/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getReportEarningHistoryListQueryKey = (params?: ReportEarningHistoryListParams) => {
  return [`/api/v1/report/earning-history/`, ...(params ? [params] : [])] as const
}

export const getReportEarningHistoryListQueryOptions = <
  TData = Awaited<ReturnType<typeof reportEarningHistoryList>>,
  TError = unknown,
>(
  params?: ReportEarningHistoryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportEarningHistoryList>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getReportEarningHistoryListQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportEarningHistoryList>>> = ({
    signal,
  }) => reportEarningHistoryList(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof reportEarningHistoryList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportEarningHistoryListQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportEarningHistoryList>>
>
export type ReportEarningHistoryListQueryError = unknown

export function useReportEarningHistoryList<
  TData = Awaited<ReturnType<typeof reportEarningHistoryList>>,
  TError = unknown,
>(
  params: undefined | ReportEarningHistoryListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportEarningHistoryList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportEarningHistoryList>>,
          TError,
          Awaited<ReturnType<typeof reportEarningHistoryList>>
        >,
        'initialData'
      >
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportEarningHistoryList<
  TData = Awaited<ReturnType<typeof reportEarningHistoryList>>,
  TError = unknown,
>(
  params?: ReportEarningHistoryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportEarningHistoryList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportEarningHistoryList>>,
          TError,
          Awaited<ReturnType<typeof reportEarningHistoryList>>
        >,
        'initialData'
      >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportEarningHistoryList<
  TData = Awaited<ReturnType<typeof reportEarningHistoryList>>,
  TError = unknown,
>(
  params?: ReportEarningHistoryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportEarningHistoryList>>, TError, TData>
    >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useReportEarningHistoryList<
  TData = Awaited<ReturnType<typeof reportEarningHistoryList>>,
  TError = unknown,
>(
  params?: ReportEarningHistoryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportEarningHistoryList>>, TError, TData>
    >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportEarningHistoryListQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getReportEarningHistoryListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportEarningHistoryList>>,
  TError = unknown,
>(
  params?: ReportEarningHistoryListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportEarningHistoryList>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getReportEarningHistoryListQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportEarningHistoryList>>> = ({
    signal,
  }) => reportEarningHistoryList(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportEarningHistoryList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportEarningHistoryListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportEarningHistoryList>>
>
export type ReportEarningHistoryListSuspenseQueryError = unknown

export function useReportEarningHistoryListSuspense<
  TData = Awaited<ReturnType<typeof reportEarningHistoryList>>,
  TError = unknown,
>(
  params: undefined | ReportEarningHistoryListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportEarningHistoryList>>, TError, TData>
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportEarningHistoryListSuspense<
  TData = Awaited<ReturnType<typeof reportEarningHistoryList>>,
  TError = unknown,
>(
  params?: ReportEarningHistoryListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportEarningHistoryList>>, TError, TData>
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportEarningHistoryListSuspense<
  TData = Awaited<ReturnType<typeof reportEarningHistoryList>>,
  TError = unknown,
>(
  params?: ReportEarningHistoryListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportEarningHistoryList>>, TError, TData>
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useReportEarningHistoryListSuspense<
  TData = Awaited<ReturnType<typeof reportEarningHistoryList>>,
  TError = unknown,
>(
  params?: ReportEarningHistoryListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportEarningHistoryList>>, TError, TData>
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportEarningHistoryListSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const reportListList = (signal?: AbortSignal) => {
  return reportListListMutator<Report[]>({ url: `/api/v1/report/list/`, method: 'GET', signal })
}

export const getReportListListQueryKey = () => {
  return [`/api/v1/report/list/`] as const
}

export const getReportListListQueryOptions = <
  TData = Awaited<ReturnType<typeof reportListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof reportListList>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getReportListListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportListList>>> = ({ signal }) =>
    reportListList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof reportListList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportListListQueryResult = NonNullable<Awaited<ReturnType<typeof reportListList>>>
export type ReportListListQueryError = unknown

export function useReportListList<
  TData = Awaited<ReturnType<typeof reportListList>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof reportListList>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof reportListList>>,
        TError,
        Awaited<ReturnType<typeof reportListList>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportListList<
  TData = Awaited<ReturnType<typeof reportListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof reportListList>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof reportListList>>,
        TError,
        Awaited<ReturnType<typeof reportListList>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportListList<
  TData = Awaited<ReturnType<typeof reportListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof reportListList>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useReportListList<
  TData = Awaited<ReturnType<typeof reportListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof reportListList>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportListListQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getReportListListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportListList>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getReportListListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportListList>>> = ({ signal }) =>
    reportListList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportListList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportListListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportListList>>
>
export type ReportListListSuspenseQueryError = unknown

export function useReportListListSuspense<
  TData = Awaited<ReturnType<typeof reportListList>>,
  TError = unknown,
>(options: {
  query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportListList>>, TError, TData>>
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportListListSuspense<
  TData = Awaited<ReturnType<typeof reportListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportListList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportListListSuspense<
  TData = Awaited<ReturnType<typeof reportListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportListList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useReportListListSuspense<
  TData = Awaited<ReturnType<typeof reportListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportListList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportListListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}
